import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=3a5fcfe3&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"
import style0 from "./commodity.vue?vue&type=style&index=0&id=3a5fcfe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fcfe3",
  null
  
)

export default component.exports